// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__MuUIH","info":"Note_info__1PB0L","note":"Note_note__3nQPQ","actions":"Note_actions__3mRta"};